import {
    TOGGLE_DRAWER,
    TOGGLE_LOADING,
    TOGGLE_SNACKBAR,
    TOAST,
} from '../types'

export const toggleDrawer = () => ({
    type: TOGGLE_DRAWER
});

export const toggleLoading = () => ({
    type: TOGGLE_LOADING
});

export const toggleSnackBar = msg => ({
    type: TOGGLE_SNACKBAR,
    msg
})

export const testThunk = (ms) => dispatch => {
    dispatch(toggleLoading())
    testThunkPromise(ms).then(() => dispatch(toggleLoading()))
}

export const toast = payload => ({
    type: TOAST,
    payload
})



const testThunkPromise = (ms) => {
    return new Promise((done) => {
        setTimeout(done, ms)
    })
}